export default {"src":"/_next/static/media/squares.85fd5b80.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};